import { render } from "./mygoodordertuikuan.vue?vue&type=template&id=9cc8a988&scoped=true"
import script from "./mygoodordertuikuan.vue?vue&type=script&lang=js"
export * from "./mygoodordertuikuan.vue?vue&type=script&lang=js"

import "./mygoodordertuikuan.vue?vue&type=style&index=0&id=9cc8a988&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cc8a988"]])

export default __exports__